export const languages = [
  { code: '1', label: 'Croatian', flag: 'https://flagcdn.com/hr.svg' },
  { code: '2', label: 'English', flag: 'https://flagcdn.com/gb.svg' },
  //{ code: 'de', label: 'German', flag: 'https://flagcdn.com/de.svg' },
];